import { createSelector } from 'reselect';

import type { Assets } from '@/types';
import selectors from '../../selectors.js';
import type { FiatProviderAssetList } from '../types.js';

const createSupportedBuyAssetsSelector = (providerName?: string) =>
  createSelector(
    selectors.assets.all,
    selectors.fiatRamp.cryptoAssets,
    selectors.enabledAssets.getIsEnabled,
    selectors.fiatRamp.isBuySupportedByAsset,
    (
      assets: Assets,
      cryptoAssets: FiatProviderAssetList,
      getIsEnabled: (name: string) => boolean,
      isBuySupportedByAsset: (name: string) => boolean,
    ) =>
      Object.values(cryptoAssets)
        .filter(
          (asset) =>
            (!providerName || asset.providers[providerName] !== undefined) &&
            getIsEnabled(asset.name) &&
            isBuySupportedByAsset(asset.name),
        )
        .map((asset) => assets[asset.name]),
  );

export default createSupportedBuyAssetsSelector;
